import OfferDocIndex from "@/views/offer-document/OfferDocIndex.vue";
import OfferDocForm from "@/views/offer-document/OfferDocForm.vue";
import OfferDocDetail from "@/views/offer-document/OfferDocDetail.vue";

const offerDoc = [
  {
    path: "/offerdocuments",
    name: "offerdocument",
    component: OfferDocIndex,
    meta: {
      requiresAuth: true,
      roles: ["Super Admin", "Admin Office"],
    },
  },
  {
    path: "/offerdocuments/add",
    name: "offerdocumentAdd",
    component: OfferDocForm,
    meta: {
      requiresAuth: true,
      roles: ["Super Admin", "Admin Office"],
    },
  },
  {
    path: "/offerdocuments/edit/:uuid",
    name: "offerdocumentEdit",
    component: OfferDocForm,
    meta: {
      requiresAuth: true,
      roles: ["Super Admin", "Admin Office"],
    },
  },
  {
    path: "/offerdocuments/detail/:uuid",
    name: "offerdocumentDetail",
    component: OfferDocDetail,
    meta: {
      requiresAuth: true,
      roles: ["Super Admin", "Admin Office"],
    },
  },
];

export default offerDoc;
